<template>
    <button @click="$emit('click', value)"
            class="btn btn-icon d-block w-100"
            :class="large?'btn-icon-lg':'btn-icon-sm'">
        <img :src="src" v-if="src" :alt="text"> {{text}}
        <span class="btn-subtitle" v-if="subtitle">{{subtitle}}</span>
    </button>
</template>

<script>
    export default {
        props: [
            'src', 'value', 'text', 'icon', 'large', 'subtitle'
        ],
        computed: {
            size() {
                return this.large ? 100 : 50;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn-icon {
        font-family: "Open Sans", serif;
        border-radius: 6px;
        background: #fff;
        padding: 20px 15px;
        box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
        font-weight: bold;
        text-transform: uppercase;
        font-size: 14px;
        color: #000;
    }

    .btn-icon-lg {
        font-size: 18px;
    }

    img {
        display: block;
        margin: 0 auto 10px;
        max-height: 130px;
    }

    .btn-subtitle {
        display: block;
        font-size: 11px;
        text-transform: initial;
        color: #999;
        font-weight: 400;
    }
</style>